<div class="partner-add-form">
  <form [formGroup]="addForm" (ngSubmit)="submit()">
    <div class="form-header">
      <h5 class="mb-0 font-size-14">{{ 'partner.add.form.title' | translate }}</h5>
    </div>
    <div class="form-body">
      <div class="upper-content d-flex flex-lg-row flex-column">
        <div class="form-floating rounded">
          <input
            type="text"
            class="form-control border"
            id="username"
            formControlName="fullName"
            [placeholder]="'partner.add.form.fullname.label' | translate"
          />
          <label for="username">{{ 'partner.add.form.fullname.label' | translate : { fgbdefault: 'Username' } }}</label>
        </div>
        <div class="form-floating rounded">
          <input
            type="text"
            class="form-control border"
            id="username"
            formControlName="email"
            [placeholder]="'partner.add.form.email.label' | translate"
          />
          <label for="username">{{ 'partner.add.form.email.label' | translate : { fgbdefault: 'Username' } }}</label>
        </div>
      </div>
      <div class="error-message">
        <fgbcl-errors></fgbcl-errors>
      </div>
    </div>
    <div class="form-footer">
      <button (click)="close(); $event.preventDefault()" class="btn btn-cancel text-danger fw-bold">
        {{ 'partner.add.form.cancel.button' | translate }}
      </button>
      <button type="submit" [disabled]="addForm.invalid" class="btn btn-success fw-bold">
        {{ 'partner.add.form.submit.button' | translate }}
      </button>
    </div>
  </form>
</div>
